import React from 'react';
import { FormComponent } from '../../../../components/form/DynamicForm'
import { Form, Validators } from '../../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../../Http';

class PagoSucursal extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'contra-recibo', saveUrl: 'contra-recibo/save', backUrl: 'jfhdfs' },
      new Form([
        Form.Field('select', 'id_sucursal', 'Sucursal', this.props.sucursal?.id_sucursal || 0, [Validators.required], 6),
        Form.Field('number', 'porcentaje', 'Porcentaje', this.props.sucursal?.porcentaje || 0, [Validators.required], 6),
      ], ['Guardar'], 'Pago por sucursal'), this.formData
    )

    // this.LoadPreds(this.props.factura.id, false);
  }

  formData = async (form) => {
    let newForm = form;
    let Res = await Http.get('sucursal/all');
    console.log(Res);
    if (!Res.error) {
      newForm = Form.FieldOptions(form, 'id_sucursal', [...Res.data], 'id', 'sucursal_nombre');
    }
    return newForm;
  }

  onSubmit = async (button, vals) => {
    // console.log(vals);
    this.saveSucursal(vals);
  }

  saveSucursal = async (sucursal) => {
    this.setState({ loading: true });
    try {
      // console.log(vals);
      let res = await Http.post(`cliente/${this.props.idCliente}/pago-transportista/sucursal`, {
        ...sucursal,
        id: this.props.sucursal?.id || null
      });
      console.log(res);
      if(!res.error) this.props.onSave();
    } catch (error) {
      console.log(error)
    }
    this.setState({ loading: false });
  }

  render() {
    return (
      <div style={{ backgroundColor: 'white' }}>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(PagoSucursal)
